












import { BFormInput } from "bootstrap-vue";

export default {
    components: {
        BFormInput,
    },
    data() {
        return {
            searchQuery: "",
        };
    },
    emits: ["searchValueChanged"],
    watch: {
        // @ts-ignore
        searchQuery(newQuery, oldQuery) {
            // @ts-ignore
            this.$emit("searchValueChanged", newQuery);
        },
    },
};
